export const Failed_Load = 'Failed_Load';
export const Push_AccuRanker_Data = 'Push_AccuRanker_Data';
export const Get_AccuRanker_Data = 'Get_AccuRanker_Data';
export const Clear_Google_Sheet_Data = 'Clear_Google_Sheet_Data';
export const UPDATE_GRID = 'UPDATE_GRID';
export const FILTER_ROWS = 'FILTER_ROWS';
export const STORE_REF_DATA = "STORE_REF_DATA";
export const SET_CDP_DATA = 'SET_CDP_DATA';
export const UPLOAD_CSV_DATA = 'UPLOAD_CSV_DATA';
export const SET_SEO_CONTENT_DATA = 'SET_SEO_CONTENT_DATA';
export const SEO_CONTENT_LOADING = 'SEO_CONTENT_LOADING';
export const GET_SEO_CONTENT_BY_ID = 'GET_SEO_CONTENT_BY_ID';
export const UPDATE_SEO_CONTENT_IN_ROWS = 'UPDATE_SEO_CONTENT_IN_ROWS';
export const UPDATE_SINGLE_ROW = 'UPDATE_SINGLE_ROW';

// Content generation action types
export const GENERATE_CONTENT_START = 'GENERATE_CONTENT_START';
export const GENERATE_CONTENT_POLLING = 'GENERATE_CONTENT_POLLING';
export const GENERATE_CONTENT_SUCCESS = 'GENERATE_CONTENT_SUCCESS';
export const GENERATE_CONTENT_ERROR = 'GENERATE_CONTENT_ERROR';
